import { core, toJSONArray } from '@tock/coretypes';

import AppConstants from 'constants/AppConstants';

interface State {
  ticketTypes: core.TicketType[];
  isInitialized: boolean;
  isRequestInProgress: boolean;
}

const initialState: State = {
  ticketTypes: [],
  isInitialized: false,
  isRequestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.ACTIVE_TICKETS_FETCH_ALL_STARTING: {
      return {
        ...state,
        ticketTypes: initialState.ticketTypes,
        isRequestInProgress: true,
      };
    }

    case AppConstants.ACTIVE_TICKETS_FETCH_ALL_FAILED: {
      return {
        ...state,
        isRequestInProgress: false,
        isInitialized: true,
      };
    }

    case AppConstants.ACTIVE_TICKETS_FETCH_ALL_DONE: {
      const data = toJSONArray<core.TicketType>(payload);
      return {
        ...state,
        ticketTypes: data,
        isInitialized: true,
        isRequestInProgress: false,
      };
    }

    default:
      return state;
  }
}
